import Button from "./partials/Button";
import jlt from "../assets/jltlogo.png";
import NavBar from "./NavBar";

const Hero = () => {
  return (
    <div className="px-10 rounded-b-3xl z-1 pb-20 mb-10 bg-gradient-to-b from-transparent from-20% via-transparent-accent via-90% to-transparent-accent to-99%">
      <div className="">
        <NavBar />
        <div className="flex flex-col justify-center items-center gap-y-5">
          <div className="animate-fade-up animate-duration-1000">
            <img src={jlt} alt="JLT" />
          </div>
          <div className="w-2/5 sm:w-2/5 md:w-1/4 lg:w-1/4 animate-pulse">
            <Button
              buttonTitle="Let's connect!"
              href="/src/components/Contact.js"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
